import { render, staticRenderFns } from "./offinegoods.vue?vue&type=template&id=165a8c3a&scoped=true&"
import script from "./offinegoods.vue?vue&type=script&lang=js&"
export * from "./offinegoods.vue?vue&type=script&lang=js&"
import style0 from "./offinegoods.vue?vue&type=style&index=0&id=165a8c3a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165a8c3a",
  null
  
)

export default component.exports